var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-table',_vm._b({ref:"table",attrs:{"no-filters":"","no-search":""},on:{"detail":_vm.handleDetailClick,"remove":_vm.handleRemoveClick}},'r-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }